import { Link } from "react-router-dom";
import { usePageMeta } from "@/hooks/use-page-meta";
import { useI18n } from "@/i18n";

export function NotFoundPage() {
  const { t } = useI18n();
  usePageMeta({ title: t.meta.notFoundTitle });

  return (
    <div className="flex min-h-[70vh] items-center justify-center px-4 pt-24">
      <div className="max-w-md text-center">
        <h1 className="text-7xl font-bold text-foreground">404</h1>
        <h2 className="mt-4 text-xl font-semibold text-foreground">{t.notFound.title}</h2>
        <p className="mt-2 text-sm text-muted-foreground">{t.notFound.copy}</p>
        <div className="mt-6">
          <Link
            to="/"
            className="inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90"
          >
            {t.notFound.goHome}
          </Link>
        </div>
      </div>
    </div>
  );
}
